<span *ngIf="shouldShowMenuOption()" class="fm-search-light-category-menu-option">
  <span class="fm-search-light-category-menu-option__text">
    {{ category.localisedEntityType }} ({{ category.items.length }})
  </span>
</span>
